module.exports = __webpack_public_path__ + "img/grafico1.a693105a.png";